import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'
import styles from './ListImageBoxItem.module.sass'


interface Props {
  item: MenuItemType
  className?: string
  editMode?: boolean
}

const ListImageBoxItem = (props: Props) => {

  const { 
    item = undefined,
    className = '',
    editMode = false,
  } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      {!!getIcon(item.style) && <div className={styles.icon}>{getIcon(item.style)}</div>}
      {!!item.name && (
        editMode || (typeof item.name !== 'string')
        ? <div className={styles.title}>{item.name}</div>
        : <p className={styles.title}>{item.name}</p>
      )}
      {!!item.description && (
        editMode || (typeof item.description !== 'string')
        ? <div className={styles.description}>{item.description}</div>
        : <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description}} />
      )}
    </div>
  ) : <></>
}

export default ListImageBoxItem
